const brandCategory = (items, categoryArray) =>
  items.filter((item) => categoryArray.includes(item.category));

const ratingCategory = (items, categoryArray) => {
  let newProds = [];

  if (categoryArray.includes("star5")) {
    let list = items.filter((item) => Number(item.rating) > 4.9);
    newProds.push(...list);
  }
  if (categoryArray.includes("star4")) {
    let list = items.filter(
      (item) => Number(item.rating) > 4.8 && Number(item.rating) < 4.9
    );
    newProds.push(...list);
  }
  if (categoryArray.includes("star3")) {
    let list = items.filter(
      (item) => Number(item.rating) > 4.7 && Number(item.rating) < 4.8
    );
    newProds.push(...list);
  }
  if (categoryArray.includes("star2")) {
    let list = items.filter(
      (item) => Number(item.rating) > 4.6 && Number(item.rating) < 4.7
    );
    newProds.push(...list);
  }
  if (categoryArray.includes("star1")) {
    let list = items.filter(
      (item) => Number(item.rating) > 4 && Number(item.rating) < 4.6
    );
    newProds.push(...list);
  }

  return newProds;
};

const priceRangeCategory = (items, categoryArray) => {
  let newProds = [];

  if (categoryArray.includes("under500")) {
    let list = items.filter((item) => Number(item.price) <= 500);
    newProds.push(...list);
  }
  if (categoryArray.includes("price1000To3000")) {
    let list = items.filter(
      (item) => Number(item.price) > 1000 && Number(item.price) < 3000
    );
    newProds.push(...list);
  }

  return newProds;
};

export { brandCategory, ratingCategory, priceRangeCategory };
